import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import video from "./video.mp4";
import backgroundImage from "./tech-background-fallback.png";
import "./Hero.css";

const Hero = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [useFallback, setUseFallback] = useState(false);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    // Si el navegador bloquea autoplay o falla la carga, mostramos fallback.
    const tryPlay = async () => {
      try {
        const p = v.play();
        if (p && typeof (p as Promise<void>).then === "function") {
          await p;
        }
        // si reproduce, fallback off
        setUseFallback(false);
      } catch {
        setUseFallback(true);
      }
    };

    tryPlay();
  }, []);

  return (
    <section className="hero">
      <div className="video-background">
        {/* VIDEO */}
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster={backgroundImage}
          onCanPlay={() => setUseFallback(false)}
          onError={() => setUseFallback(true)}
        >
          <source src={video} type="video/mp4" />
        </video>

        {/* FALLBACK: SOLO si falla el video */}
        {useFallback && (
          <img
            className="hero-fallback-image"
            src={backgroundImage}
            alt="Technology background"
          />
        )}

        <div className="video-overlay"></div>
      </div>

      <div className="floating-element"></div>
      <div className="floating-element"></div>
      <div className="floating-element"></div>

      <div className="hero-content">
        <h1 className="hero-title">Diseñamos Espacios Conectamos Personas</h1>
        <p className="hero-subtitle">
          Soluciones en telecomunicaciones y arquitectura sostenible diseñadas para el
          
          mundo digital
        </p>

        <div className="hero-buttons">
          {/* ✅ A contacto */}
          <Link to="/#contacto" className="cta-button">
            Solicitar Propuesta
          </Link>

          {/* ✅ A servicios */}
          <Link to="/#servicios" className="btn-secondary">
            Ver Tecnologías
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;